import { render, staticRenderFns } from "./ModalGroup.vue?vue&type=template&id=52addf40&scoped=true&"
import script from "./ModalGroup.vue?vue&type=script&lang=js&"
export * from "./ModalGroup.vue?vue&type=script&lang=js&"
import style0 from "./ModalGroup.vue?vue&type=style&index=0&id=52addf40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52addf40",
  null
  
)

export default component.exports